import React from 'react';
import { Text, Box } from '@wix/design-system';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';
export function InstalledBadge({ children, size = 'tiny', }) {
    return (React.createElement(Box, { gap: "4px", verticalAlign: "middle" },
        React.createElement(StatusCompleteFilledSmall, { color: "#60bc57" }),
        React.createElement(Text, { size: size, weight: "thin", skin: "success", dataHook: "installed-text" }, children)));
}
//# sourceMappingURL=installed-badge.js.map